// extracted by mini-css-extract-plugin
module.exports = {"cardsList":"Cards_cardsList__2z3qS"};